module.exports = __webpack_public_path__ + "static/img/waterdudv.3def385.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/parts/scene-area/ThreeJS/textures/waterdudv.jpg
// module id = 561
// module chunks = 2